import { Box, Text } from '@cmpsr/components';

export default function RiskAnalysisTitle() {
  return (
    <Box mb={7}>
      <Text as="h1" variant="text-header-4XL" mb={2} color="tan">
        Risk{' '}
        <Text as="span" textStyle="text-header-4xl-v" color="tan">
          Analysis
        </Text>
      </Text>
      <Text variant="text-body-regular" fontSize={{ base: '14px', lg: '16px' }} color="tan">
        Your Risk Analysis shows how your unique cancer risk maps to specific risk factors, and how your risk can change
        over time.
      </Text>
    </Box>
  );
}
